import { FirebaseConfig } from "@/interfaces/customTypes/configProperties";
import { AppUserContext } from "@/providers/AppContextProvider";
import { syncProjectFileUploaderContext } from "./projectFileUploader";

export function syncUtilitiesContext(userContext: AppUserContext | undefined, firebaseConfig: FirebaseConfig) {
  syncProjectFileUploaderContext(userContext, firebaseConfig);
}
